let counter = 0;

export function generateId(prefix = 'id'): string {
  counter = (counter + 1) & 0xffff;
  return `${prefix}_${Date.now().toString(36)}_${counter.toString(36)}`;
}
